import GUI from "lil-gui";

// Debug UI
export const gui = new GUI();
